// Signup/Signup.jsx
// Modern, professional signup page with enhanced UX

import React from 'react';
import { styles } from './styles';
import { useSignupForm } from './useSignupForm';
import SignupForm from './SignupForm';
import { UniversityIcon } from '../../components/Icons';
import './Signup.css';

const Signup = () => {
  const {
    formData,
    updateField,
    validationErrors,
    loading,
    handleSignup,
    navigateToLogin
  } = useSignupForm();

  // Detect Brave browser
  const [isBrave, setIsBrave] = React.useState(false);
  
  React.useEffect(() => {
    if (navigator.brave && typeof navigator.brave.isBrave === 'function') {
      navigator.brave.isBrave().then((result) => {
        setIsBrave(result);
      });
    }
  }, []);

  return (
    <div style={styles.container}>
      {/* Background decoration for modern aesthetic */}
      <div style={styles.backgroundDecoration}></div>
      
      {/* Main signup card with professional design */}
      <div style={styles.signupCard} className="signup-card">
        {/* Header with ISU branding and modern typography */}
        <div style={styles.header}>
          <div style={styles.brandSection}>
            <div style={styles.brandIcon}>
              <UniversityIcon size={24} color="white" />
            </div>
            <h1 style={styles.brandText} className="brand-text">Redbird Markets</h1>
          </div>
          <h2 style={styles.title} className="signup-title">Join Our Community</h2>
          <p style={styles.subtitle} className="signup-subtitle">
            Create your Illinois State University marketplace account and start connecting with fellow Redbirds to buy and sell safely.
          </p>
        </div>
        
        {/* Brave Shields Warning */}
        {isBrave && (
          <div style={{
            background: '#fff3cd',
            border: '1px solid #ffc107',
            borderRadius: '8px',
            padding: '12px 16px',
            marginBottom: '16px',
            fontSize: '14px',
            color: '#856404'
          }}>
            <strong>⚠️ Brave Browser Detected:</strong> If you experience signup issues, please click the lion icon in your address bar and disable Shields for this site, or use a different browser.
          </div>
        )}
        
        {/* Signup form section with modern inputs */}
        <div style={styles.formSection}>
          <SignupForm
            formData={formData}
            onFieldUpdate={updateField}
            validationErrors={validationErrors}
            loading={loading}
            onSubmit={handleSignup}
          />
        </div>
        
        {/* Login prompt with call-to-action design */}
        <div style={styles.loginSection}>
          <p style={styles.loginText}>
            Already have an account?
          </p>
          <button
            style={styles.loginButton}
            onClick={navigateToLogin}
            className="login-button"
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#CE1126';
              e.target.style.color = 'white';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 24px rgba(206, 17, 38, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#CE1126';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            Sign In Instead
          </button>
        </div>
      </div>
    </div>
  );
};

export default Signup;